import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  type: 'paidSearch',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  paidSearchRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  }
}

const paidSearchSlice = createSlice({
  name: 'paidSearch',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload }
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload }
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload }
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload }
    },
    setPaidSearchRange: (state, action) => {
      return { ...state, paidSearchRange: action.payload }
    }
  }
})

export const paidSearchActions = paidSearchSlice.actions

export default paidSearchSlice.reducer
